import { Link, useNavigate } from 'react-router-dom';
import Avatar, { toInitials } from './Avatar';
import Btn from './Btn';
import { LogoLockup } from './Logo';
import { api } from '../../lib/api';
import { useAuthStore } from '../../stores/auth';

/**
 * Top bar shared by every authenticated screen. Layout follows the
 * maquettes (M3 / M4 / M1): logo + wordmark stack on the left,
 * actions on the right (warning chip when must_change_password,
 * avatar, logout).
 */
export default function AppHeader() {
  const user = useAuthStore((s) => s.user);
  const refreshToken = useAuthStore((s) => s.refreshToken);
  const clear = useAuthStore((s) => s.clear);
  const navigate = useNavigate();

  const onLogout = async () => {
    try {
      await api.post('/auth/logout', { refresh_token: refreshToken });
    } catch {
      /* already gone — clear locally */
    }
    clear();
    navigate('/login');
  };

  return (
    <header className="flex h-14 items-center justify-between border-b border-rule bg-paper-elevated px-5">
      <Link to="/" className="no-underline" aria-label="ADR — Analyse de Dossier Répressif">
        <LogoLockup />
      </Link>
      {user && (
        <div className="flex items-center gap-3.5 text-[13px] text-text-secondary">
          {user.must_change_password && (
            <Link
              to="/account/password"
              className="rounded-pill bg-status-warning-bg px-2.5 py-[3px] text-[11px] text-status-warning-text no-underline hover:opacity-90"
            >
              mot de passe à changer →
            </Link>
          )}
          <span className="hidden sm:inline">
            <strong className="font-medium text-text-primary">{user.display_name}</strong>
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.2px] rounded-pill border border-rule bg-paper-subtle px-2 py-[3px] text-text-secondary">
            {user.role}
          </span>
          {(user.role === 'admin_cabinet' || user.role === 'super_admin') && (
            <Link
              to="/admin"
              className="rounded-pill border border-rule bg-paper-subtle px-2.5 py-[3px] text-[11px] text-text-secondary no-underline hover:text-text-primary"
              title="Administration cabinet"
            >
              ⚙ Admin
            </Link>
          )}
          <Avatar initials={toInitials(user.display_name)} title={user.display_name} />
          <Btn variant="secondary" size="sm" onClick={onLogout}>
            Se déconnecter
          </Btn>
        </div>
      )}
    </header>
  );
}
